import Node from './node'
import Link from './link'

import canvasConstants from './canvasConstants'

// Default press, move & click interactions
function defaultPress (context, x, y) {
  const state = context.state
  const actionData = state.canvasActionData

  // search list of nodes to see if any were pressed
  let pressedNode = null
  state.nodes.forEach(node => {
    if (node.isIn(x, y)) {
      pressedNode = node
    }
  })

  if (pressedNode !== null) {
    actionData.activeNodeID = pressedNode.id
  }
}

function defaultMove (context, dx, dy) {
  const state = context.state
  const isPriveleged = context.rootState.challenge.currentlyViewedChallenge.isFacilitator || context.rootState.challenge.currentlyViewedChallenge.isCofacilitator
  const activeNodeID = state.canvasActionData.activeNodeID
  const canvasActionData = state.canvasActionData

  if ((activeNodeID !== undefined) && isPriveleged) {
    // there is an active node, drag that
    if (canvasActionData.startX === undefined) {
      canvasActionData.startX = state.nodeMap[activeNodeID].pos[0]
      canvasActionData.startY = state.nodeMap[activeNodeID].pos[1]
      canvasActionData.dx = 0
      canvasActionData.dy = 0
    } else {
      canvasActionData.dx += dx / state.canvasZoom
      canvasActionData.dy += dy / state.canvasZoom
    }

    context.dispatch('moveNode', {
      nodeID: activeNodeID,
      newx: canvasActionData.startX + canvasActionData.dx,
      newy: canvasActionData.startY + canvasActionData.dy
    })
  } else {
    // no active node, drag the entire canvas
    state.canvasPos[0] -= dx
    state.canvasPos[1] -= dy
  }
}

function defaultClick (context, x, y) {
  const state = context.state
  const isPriveleged = context.rootState.challenge.currentlyViewedChallenge.isFacilitator || context.rootState.challenge.currentlyViewedChallenge.isCofacilitator
  const isFacilitator = context.rootState.challenge.currentlyViewedChallenge.isFacilitator
  // const isFacilitator = false
  let clickable = null

  // search list of nodes to see if any were clicked
  state.nodes.forEach(node => {
    if (node.isIn(x, y)) {
      clickable = node
    }
  })

  // search list of links to see if any were clicked
  state.links.forEach(link => {
    if (link.isIn(x, y)) {
      clickable = link
    }
  })

  if (clickable instanceof Node) {
    if (clickable.isInPinBox(x, y)) {
      if (isFacilitator) {
        context.commit('setSelectedNodePinsID', clickable.id)
      } else {
        context.dispatch('changeNodePin', {
          nodeID: clickable.id,
          pinState: !clickable.pinnedByMe
        })
      }
    } else if (isPriveleged) {
      context.commit('setSelectedNodeID', clickable.id)
    }
  } else if ((clickable instanceof Link) && isPriveleged) {
    context.commit('setSelectedLinkID', clickable.id)
  }
}

function defaultRelease (context) {
  context.state.canvasActionData.activeNodeID = undefined
  context.state.canvasActionData.startX = undefined
  context.state.canvasActionData.startY = undefined
  context.state.canvasActionData.dx = undefined
  context.state.canvasActionData.dy = undefined
}

// special click interactions
function doAddNode ({ dispatch, state, rootState }, x, y) {
  const defaultText = rootState.challenge.currentlyViewedChallenge.phrase

  const fitNode = new Node() /* TODO(Jon): this is really sloppy */
  const fitSize = fitNode.getFitSize(state.diagramCtx, defaultText,
    canvasConstants.defaultNodeFont,
    canvasConstants.defaultNodeWidth, canvasConstants.defaultNodeHeight)

  console.log(rootState.challenge.currentlyViewedChallenge.defaultDotColor)

  dispatch('createNode', {
    x: x,
    y: y,
    width: fitSize.width,
    height: fitSize.height,
    text: defaultText,
    fill: rootState.challenge.currentlyViewedChallenge.defaultNodeColor,
    font: canvasConstants.defaultNodeFont,
    fontColor: rootState.challenge.currentlyViewedChallenge.defaultFontColor,
    dotColor: rootState.challenge.currentlyViewedChallenge.defaultDotColor
  })

  state.canvasAction = MODES.Default
  state.canvasActionData = {}
}

function doAddLink (context, x, y) {
  const state = context.state
  const canvasActionData = state.canvasActionData

  let clickable = null

  // search list of nodes to see if any were clicked
  state.nodes.forEach(node => {
    if (node.isIn(x, y)) {
      clickable = node
    }
  })

  if (clickable instanceof Node) {
    if (canvasActionData.A === undefined) {
      canvasActionData.A = clickable
    } else if (canvasActionData.A !== clickable) {
      const A = canvasActionData.A
      const B = clickable

      let linkExists = false
      state.links.forEach(link => {
        if (((link.A === A) && (link.B === B)) || ((link.A === A) && (link.B === B))) {
          linkExists = true
        }
      })

      // only create new links that are not to self
      if (!linkExists && (canvasActionData.A.id !== clickable.id)) {
        context.dispatch('createLink', {
          nodeAID: canvasActionData.A.id,
          nodeBID: clickable.id,
          thickness: canvasConstants.defaultLinkThickness,
          color: context.rootState.challenge.currentlyViewedChallenge.defaultLinkColor
        })
      }

      state.canvasAction = MODES.Default
      state.canvasActionData = {}
    }
  }
}

function doCopyNode (context, x, y) {
  const state = context.state
  let clickable = null

  // search list of nodes to see if any were clicked
  state.nodes.forEach(node => {
    if (node.isIn(x, y)) {
      clickable = node
    }
  })

  if (clickable instanceof Node) {
    context.dispatch('createNode', {
      x: x,
      y: y,
      width: clickable.size[0],
      height: clickable.size[1],
      text: clickable.text,
      fill: clickable.fill,
      font: clickable.font,
      fontColor: clickable.fontColor,
      dotColor: clickable.dotColor
    })

    state.canvasAction = MODES.Default
    state.canvasActionData = {}
  }
}

// select drag interaction
function selectPress (context, x, y) {
  const state = context.state
  const actionData = state.canvasActionData
  const selectedNodeIDs = actionData.selectedNodeIDs

  // search list of nodes to see if any were pressed
  let pressedNode = null
  state.nodes.forEach(node => {
    if (node.isIn(x, y)) {
      pressedNode = node
    }
  })

  const noSelectedNodes = selectedNodeIDs === undefined
  const clickedCanvas = pressedNode === null
  const clickedNonSelectedNode = (selectedNodeIDs !== undefined) && (pressedNode !== null) && !selectedNodeIDs.includes(pressedNode.id)

  if (noSelectedNodes || clickedCanvas || clickedNonSelectedNode) {
    // delete old selection & start new one
    actionData.selectedNodeIDs = undefined
    actionData.startP = { x: x, y: y }
    actionData.endP = { x: x, y: y }
  }
}

function selectMove (context, dx, dy) {
  const state = context.state
  const actionData = state.canvasActionData
  const selectedNodeIDs = actionData.selectedNodeIDs

  if (selectedNodeIDs !== undefined) {
    actionData.dx = (actionData.dx || 0) + (dx / state.canvasZoom)
    actionData.dy = (actionData.dy || 0) + (dy / state.canvasZoom)

    // move all selected nodes
    state.nodes.forEach(node => {
      if (selectedNodeIDs.includes(node.id)) {
        context.dispatch('moveNode', {
          nodeID: node.id,
          newx: actionData.selectedNodeStarts[node.id][0] + actionData.dx,
          newy: actionData.selectedNodeStarts[node.id][1] + actionData.dy
        })
      }
    })
  } else {
    // move end point of selected bounds
    actionData.endP.x += dx / state.canvasZoom
    actionData.endP.y += dy / state.canvasZoom
  }
}

function selectRelease (context) {
  const state = context.state
  const actionData = state.canvasActionData

  if ((actionData.startP !== undefined) && (actionData.endP !== undefined)) {
    const minX = Math.min(actionData.startP.x, actionData.endP.x)
    const maxX = Math.max(actionData.startP.x, actionData.endP.x)
    const minY = Math.min(actionData.startP.y, actionData.endP.y)
    const maxY = Math.max(actionData.startP.y, actionData.endP.y)

    // create selected nodes array
    actionData.selectedNodeIDs = []
    actionData.selectedNodeStarts = {}
    state.nodes.forEach(node => {
      if ((minX < node.pos[0]) && (node.pos[0] < maxX) &&
          (minY < node.pos[1]) && (node.pos[1] < maxY)) {
        actionData.selectedNodeIDs.push(node.id)
        actionData.selectedNodeStarts[node.id] = [...node.pos]
      }
    })

    actionData.dx = undefined
    actionData.dy = undefined

    // remove bounds start and end point
    actionData.startP = undefined
    actionData.endP = undefined
  }
}

// edit node size interactions
function editPress (context, x, y) {
  const state = context.state
  const actionData = state.canvasActionData

  // search list of nodes to see if any were pressed
  state.nodes.forEach(node => {
    if (node.isInPosHandle(x, y)) {
      actionData.nodeID = node.id
      actionData.dragType = 'POSH'
    } else if (node.isInSizeHandle(x, y)) {
      actionData.nodeID = node.id
      actionData.dragType = 'SIZEH'
    } else if (node.isIn(x, y)) {
      actionData.nodeID = node.id
      actionData.dragType = 'POS'
    }
  })
}

function editMove (context, dx, dy) {
  const state = context.state
  const dragType = state.canvasActionData.dragType
  const nodeID = state.canvasActionData.nodeID

  if (nodeID !== undefined) {
    const node = state.nodeMap[nodeID]

    if (dragType === 'POSH') {
      const oldWidth = node.size[0]
      const oldHeight = node.size[1]

      const fitSize = node.getFitSize(state.diagramCtx, node.text, node.font,
        node.size[0] - dx / state.canvasZoom,
        node.size[1] - dy / state.canvasZoom
      )

      context.dispatch('resizeNode', {
        nodeID: nodeID,
        newWidth: fitSize.width,
        newHeight: fitSize.height
      })

      context.dispatch('moveNode', {
        nodeID: nodeID,
        newx: node.pos[0] - (fitSize.width - oldWidth),
        newy: node.pos[1] - (fitSize.height - oldHeight)
      })
    } else if (dragType === 'SIZEH') {
      const fitSize = node.getFitSize(state.diagramCtx, node.text, node.font,
        node.size[0] + dx / state.canvasZoom,
        node.size[1] + dy / state.canvasZoom
      )

      context.dispatch('resizeNode', {
        nodeID: nodeID,
        newWidth: fitSize.width,
        newHeight: fitSize.height
      })
    } else if (dragType === 'POS') {
      // there is an active node, drag that
      context.dispatch('moveNode', {
        nodeID: nodeID,
        newx: node.pos[0] + dx / state.canvasZoom,
        newy: node.pos[1] + dy / state.canvasZoom
      })
    }
  } else {
    // no active node, drag the entire canvas
    state.canvasPos[0] -= dx
    state.canvasPos[1] -= dy
  }
}

function editRelease (context) {
  const state = context.state
  const actionData = state.canvasActionData

  actionData.nodeID = undefined
  actionData.dragType = undefined
}

const MODES = {
  Default: {
    onClick: defaultClick,
    onPress: defaultPress,
    onMove: defaultMove,
    onRelease: defaultRelease
  },
  AddNode: {
    onClick: doAddNode,
    onPress: defaultPress,
    onMove: defaultMove,
    onRelease: defaultRelease
  },
  AddLink: {
    onClick: doAddLink,
    onPress: defaultPress,
    onMove: defaultMove,
    onRelease: defaultRelease
  },
  EditNode: {
    onClick: defaultClick,
    onPress: editPress,
    onMove: editMove,
    onRelease: editRelease
  },
  SelectNodes: {
    onClick: defaultClick,
    onPress: selectPress,
    onMove: selectMove,
    onRelease: selectRelease
  },
  CopyNode: {
    onClick: doCopyNode,
    onPress: defaultPress,
    onMove: defaultMove,
    onRelease: defaultRelease
  }
}

export default MODES
